module.exports = __webpack_public_path__ + "static/workshops_title.281e2beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Workshops/Towers/workshops_title.png
// module id = 742
// module chunks = 213534597649335